module.exports = __webpack_public_path__ + "img/hkCover.ba41bc2b.png";